import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthenticationGuard, AuthenticationService } from '@sla-ng/core';
import { SlairAuthenticationGuard } from './guards/slair-authentication.guard';
import { SlairAuthenticationService } from './services/slair-authentication.service';

// Models
export * from './models/slair-user.model';

// Services
export * from './services/slair-authentication.service';

// Resources
export * from './resources/bff.resource';

// Guards
export * from './guards/slair-authentication.guard';


@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [],
    exports: [],
})
export class SlairCoreModule {
    public static forRoot(): ModuleWithProviders<SlairCoreModule> {
        return {
            ngModule: SlairCoreModule,
            providers: [
                { provide: AuthenticationService, useClass: SlairAuthenticationService },
                { provide: AuthenticationGuard, useClass: SlairAuthenticationGuard },
            ],
        };
    }
}
